<div
  *ngIf="(offersStatus$ | async) === MultiCityStatus.PENDING"
  data-testid="multi-city-loader"
  class="fill grow--min grey-25-bg flex flex--column flex--center"
>
  <fin-loader class="font-body-1" [type]="LoaderType.EMBEDDED" [title]="'ticketSelection.loading'"></fin-loader>
</div>

<ng-container
  *ngIf="
    (offersStatus$ | async) === MultiCityStatus.READY ||
    (offersStatus$ | async) === MultiCityStatus.PENDING_MORE_FLIGHTS
  "
>
  <div class="wrap pr-large-t" data-testid="multi-city-header" *ngIf="flights$ | async as flights">
    <h1 class="font-heading-3 ms-clear bold-type">
      {{ 'multiCity.flightSelection.title' | finLocalization }}
    </h1>

    <button
      data-testid="multi-city-journey-button"
      [attr.id]="'multicity-journey'"
      [attr.aria-controls]="'multicity-journey-content'"
      [attr.aria-expanded]="expandOpen"
      class="fill flex no-outline"
      (click)="expandOpen = !expandOpen"
    >
      <div class="flex align-left flex--center ms-xsmall-t">
        <p class="font-body-1 nordic-blue-900-text subtitle bold-type">
          <span class="underline">
            {{
              'multiCity.flightSelection.subtitle'
                | finLocalization
                  : {
                      noOfFlights: flights.length,
                      startDate: flights[0].departureDate | finDateFormat: 'FULL_NO_YEAR',
                      endDate: flights[flights.length - 1].departureDate | finDateFormat: 'FULL_NO_YEAR',
                    }
            }}
          </span>
        </p>
        <fcom-icon
          class="flex-1 flex--nogrow rotate icon-medium bold-type"
          [class.rotate-active]="expandOpen"
          [name]="SvgLibraryIcon.CHEVRON_DOWN"
        ></fcom-icon>
      </div>
    </button>
    <fcom-expand
      class="block"
      [open]="expandOpen"
      [ariaId]="'multicity-journey-content'"
      [ariaLabelledBy]="'multi-city-journey-button'"
    >
      <ol [attr.id]="'multicityJourney'" class="flex flex--column ms-xxsmall-y">
        <li
          *ngFor="let flight of flights; let index = index"
          class="flex flex--middle flex--space-between ps-large-r ms-medium-l list-item"
          data-testid="'flight-item-' + index"
          [id]="'flight-item-' + index"
        >
          <div class="font-body-1 capitalize location-title medium-type">
            <div class="flex fill">
              <span class="ps-xxsmall-r overflow-hidden truncate"
                >{{ flight.origin.cityName }}&ndash;{{ flight.destination.cityName }}</span
              >
            </div>
          </div>
          <div class="font-body-2 ps-xxsmall-y nordic-blue-900-text">
            <span> {{ flight.departureDate | finDateFormat: 'FULL' }}</span>
          </div>
        </li>
      </ol>
    </fcom-expand>

    <p
      class="font-body-1 nordic-blue-900-text trip-info"
      [innerHTML]="
        'multiCity.flightSelection.priceInfo'
          | finLocalization
            : {
                currencyCode: currencyCode$ | async,
                passengerTypes: 'passenger' | finLocalization | finFormatPassenger: (paxAmount$ | async),
              }
          | finSafe: 'html'
      "
    ></p>
  </div>

  <fin-multi-city-fare-family
    *ngIf="(step$ | async) === MultiCityStep.FARE_FAMILY"
    [paxAmount$]="paxAmount$"
    [flightSearch$]="flightSearch$"
    (continueToMultiCityBounds)="continueToBoundsStep($event)"
  ></fin-multi-city-fare-family>
  <fin-multi-city-bounds
    *ngIf="(step$ | async) !== MultiCityStep.FARE_FAMILY"
    [currentBound$]="step$"
    [paxAmount$]="paxAmount$"
    [amountOfBounds$]="amountOfBounds$"
    [flights$]="flights$"
    (continueToNextBound)="continueToNextBound($event)"
    (resetSelection)="resetSelection()"
    (resetToBound)="resetToBound($event)"
  ></fin-multi-city-bounds>
</ng-container>

<ng-template #informBlock let-title="title" let-content="content" let-testid="testid" let-blockClass="blockClass">
  <fin-bound-selection-error-message
    class="block ms-medium-t"
    [enableSurvey]="false"
    (ctaClick)="onTryAgain()"
    [ctaButtonText]="'bookingSearch.tryAgain' | finLocalization"
  >
    <div class="title">
      <h5 class="ms-xsmall-b">{{ title | finLocalization }}</h5>
      <p>{{ content | finLocalization }}</p>

      <p class="ms-small-t">
        {{ 'multiCity.flightSelection.faq.title' | finLocalization }}
        <fcom-link
          class="ms-xsmall-r flex--self-start"
          [href]="'multiCity.flightSelection.faq.link.url' | finLocalization"
          [openInNewTab]="true"
          [external]="true"
        >
          {{ 'multiCity.flightSelection.faq.linkTitle' | finLocalization }}</fcom-link
        >
      </p>
    </div>
    <span class="cta">{{ 'bookingSearch.tryAgain' | finLocalization }}</span>
  </fin-bound-selection-error-message>

  <fin-multi-city-survey
    [alwaysRender]="true"
    class="block no-offer-survey-block ms-medium-y mr-xxsmall-x"
  ></fin-multi-city-survey>
</ng-template>

<ng-container *ngIf="offersStatus$ | async as status">
  <ng-container *ngIf="status === MultiCityStatus.ERROR">
    <ng-container
      *ngTemplateOutlet="
        informBlock;
        context: {
          title: 'errors.booking.title',
          content: 'errors.booking.description',
          testid: 'multi-city-error',
          blockClass: 'error-info-block',
        }
      "
    ></ng-container>
  </ng-container>

  <ng-container *ngIf="status === MultiCityStatus.NO_OFFERS">
    <ng-container
      *ngTemplateOutlet="
        informBlock;
        context: {
          title: 'multiCity.flightSelection.noOffersTitle',
          content: 'multiCity.flightSelection.noOffersContent',
          testid: 'multi-city-no-flights',
          blockClass: 'no-offer-info-block',
        }
      "
    ></ng-container>
  </ng-container>
</ng-container>
